import { css } from "styled-components";
import { styledTheme } from "../../../theme/theme";

export const tertiaryButton = css<{ disabled?: boolean }>`
  background: ${styledTheme.newColors.extra.tertiaryButtonBG};
  color: ${styledTheme.newColors.grayscale.tertiaryGray};
  border: 1px solid ${styledTheme.newColors.grayscale.bordersInside};

  svg path {
    fill: ${styledTheme.newColors.grayscale.tertiaryGray};
  }

  svg {
    fill: ${styledTheme.newColors.grayscale.tertiaryGray};
  }

  &:hover {
    border: 1px solid ${styledTheme.newColors.grayscale.placeholder};

    &:active {
      border-style: inset;
    }
  }

  ${({ theme, disabled }) =>
    disabled &&
    css`
      background: ${theme.newColors.extra.tertiaryButtonBG};
      cursor: default;
      color: ${theme.newColors.grayscale.disabled};
      border: 1px solid ${theme.newColors.grayscale.disabled};

      &:hover {
        color: ${theme.newColors.grayscale.disabled};
        border: 1px solid ${theme.newColors.grayscale.disabled};

        &:active {
          border-style: outset;
        }

        svg path {
          fill: ${theme.newColors.grayscale.disabled};
        }

        svg {
          fill: ${theme.newColors.grayscale.disabled};
        }
      }

      svg path {
        fill: ${theme.newColors.grayscale.disabled};
      }

      svg {
        fill: ${theme.newColors.grayscale.disabled};
      }
    `}
`;
